/* assets/csim-handoff.js : cross-store link tagging, revision 6d (6b is live on both stores since 2026-10-29).
   Upload this file to the theme as assets/csim-handoff.js (same file on both stores).
   Rev 5 (CanadianSIM GM): forwards the LATEST campaign (latest touch), keeps the first campaign
   only as a separate optional value, no fallback UTMs, 30-day consent-gated cookie.
   Rev 6: landing UTMs are kept in page memory and written to csim_lt as soon as marketing consent
   arrives. Before consent nothing is stored on the device; instead the landing UTMs are carried in
   the URL of same-store internal links (not cart/checkout) so the campaign survives until consent.
   FORWARD_UTM_WITHOUT_CONSENT is false (rev 6b): without marketing consent, cross-store links carry
   only csim_from and csim_lid, no UTMs. Setting it to true would forward in-URL UTMs (privacy-review item).
   Rev 6d: window.csimCarryUrl(url) applies the same-store carry rules to programmatic navigation
   (plan-card 'View Plan' buttons); it returns the URL unchanged when the rules do not apply.
   It never stores, adds, removes or strips gclid, gbraid, wbraid or any _gcl_* cookie. */
(function () {
  'use strict';
  if (window.csimTagCrossStoreUrl) return;

  var HOSTS = {
    'canadiansim.com': 'postpaid',
    'www.canadiansim.com': 'postpaid',
    'prepaid.canadiansim.com': 'prepaid'
  };
  var HERE = HOSTS[location.hostname];
  if (!HERE) return;                         // *.myshopify.com previews: no-op (plan-filter.js falls back)

  var CK = 'csim_lt';                        // latest-touch cookie, marketing consent only
  var MAX_AGE = 30 * 24 * 60 * 60;           // 30 days (Safari ITP may cap script cookies at 7)
  var FORWARD_FIRST = true;                  // optional: also forward the first campaign as csim_fc
  var FORWARD_UTM_WITHOUT_CONSENT = false;    // PRIVACY REVIEW: cross-store links carry this page's in-URL
                                             // UTMs even before/without marketing consent (URL only)
  var CARRY_UTM_BEFORE_CONSENT = true;       // same-store internal links carry landing UTMs until consent
  var UTM = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_id'];
  var LANDING = new URLSearchParams(location.search);
  var reported = {};                         // csim_ho values already sent from this page
  var mktOverride = null;                    // marketing state from the visitorConsentCollected event

  function privacy() { return window.Shopify && window.Shopify.customerPrivacy; }
  function marketingOk() {
    var cp = privacy();
    if (mktOverride !== null) return mktOverride;
    return !!(cp && typeof cp.marketingAllowed === 'function' && cp.marketingAllowed());
  }
  function analyticsOk() {
    var cp = privacy();
    return !!(cp && typeof cp.analyticsProcessingAllowed === 'function' && cp.analyticsProcessingAllowed());
  }

  // UTMs on the current landing URL, unless this landing is itself a hand-off arrival.
  function landingUtm() {
    if (LANDING.has('csim_from')) return null;        // forwarded values are not a new touch
    var t = {}, has = false;
    UTM.forEach(function (k) { var v = LANDING.get(k); if (v) { t[k] = v.slice(0, 100); has = true; } });
    return has ? t : null;
  }
  var PAGE_UTM = landingUtm();               // page memory only: never stored before marketing consent

  // Cookie value: { l: { utm_*: latest touch }, fc: 'first campaign' (optional) }
  function readCk() {
    var parts = document.cookie.split('; ');
    for (var i = 0; i < parts.length; i++) {
      if (parts[i].indexOf(CK + '=') === 0) {
        try {
          var v = JSON.parse(decodeURIComponent(parts[i].slice(CK.length + 1)));
          return v && typeof v === 'object' && v.l && typeof v.l === 'object' ? v : null;
        } catch (e) { return null; }
      }
    }
    return null;
  }

  // Latest touch: a landing with UTMs stores them, or replaces the stored ones.
  // The first campaign is kept as fc and never overrides the latest.
  function writeCk() {
    if (!marketingOk()) return;
    var t = PAGE_UTM;
    if (!t) return;
    var old = readCk();
    var fc = old ? (old.fc || old.l.utm_campaign || '') : (t.utm_campaign || '');
    var v = { l: t };
    if (fc) v.fc = String(fc).slice(0, 100);
    document.cookie = CK + '=' + encodeURIComponent(JSON.stringify(v)) +
      '; Domain=.canadiansim.com; Path=/; Max-Age=' + MAX_AGE + '; Secure; SameSite=Lax';
  }

  // Latest touch to forward: this landing's UTMs first, then the cookie (marketing consent only).
  // Without marketing consent: this page's in-URL UTMs only (if FORWARD_UTM_WITHOUT_CONSENT), no cookie read.
  function latest() {
    if (!marketingOk()) return FORWARD_UTM_WITHOUT_CONSENT && PAGE_UTM ? { l: PAGE_UTM } : null;
    var ck = readCk();
    var t = PAGE_UTM;
    if (t) return { l: t, fc: ck ? (ck.fc || ck.l.utm_campaign || '') : (t.utm_campaign || '') };
    return ck;
  }

  // 16 lowercase hex characters (the pixel checks this format).
  function handoffId() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID().split('-').join('').slice(0, 16);
    var s = '';
    for (var i = 0; i < 16; i++) s += Math.floor(Math.random() * 16).toString(16);
    return s;
  }

  // Customer Events route. Shipped in the theme now; the custom pixel is switched on only after L10.
  function publish(name, data) {
    if (!analyticsOk()) return;
    var an = window.Shopify && window.Shopify.analytics;
    if (!an || typeof an.publish !== 'function') return;
    try {
      var r = an.publish('csim:' + name, data);
      if (r && typeof r.catch === 'function') r.catch(function () {});
    } catch (e) { /* ignore */ }
  }

  function otherStore(url) {
    try {
      var u = new URL(url, location.href);
      var dest = HOSTS[u.hostname];
      return dest && dest !== HERE ? u : null;
    } catch (e) { return null; }
  }

  // Returns the decorated URL, or the original URL if it does not point to the other store.
  // Only utm_*, csim_fc, csim_from, csim_lid and csim_ho are ever set; every other parameter
  // (gclid, gbraid, wbraid included) is left exactly as it was.
  function tag(url, linkId, freshId) {
    try {
      var u = otherStore(url);
      if (!u) return url;
      var p = u.searchParams;
      var hasUtm = UTM.some(function (k) { return p.has(k); });
      if (!hasUtm) {                                   // utm_* already on the link stay as they are
        var lt = latest();
        if (lt) {
          UTM.forEach(function (k) { if (lt.l[k]) p.set(k, lt.l[k]); });
          if (FORWARD_FIRST && lt.fc && lt.fc !== lt.l.utm_campaign) p.set('csim_fc', lt.fc);
        }                                              // no latest touch: no UTMs at all (no fallback)
      }
      p.set('csim_from', HERE);
      p.set('csim_lid', linkId || 'unlabelled');       // fixed link label, no consent needed
      // csim_ho needs analytics consent; freshId (pointerdown, contextmenu, keyboard click) replaces it
      if (analyticsOk() && (freshId || !p.has('csim_ho'))) p.set('csim_ho', handoffId());
      return u.toString();
    } catch (e) { return url; }
  }

  // Click-side event: best effort. It under-counts same-tab navigation; handoff_landed is the primary count.
  function report(url, linkId) {
    var u = otherStore(url);
    if (!u) return false;
    var ho = u.searchParams.get('csim_ho');
    if (!ho || reported[ho]) return false;           // no analytics consent, or already sent
    reported[ho] = true;
    publish(HERE === 'postpaid' ? 'short_stay_handoff' : 'long_stay_handoff',
      { handoff_id: ho, trigger: linkId || 'unlabelled', csim_from: HERE });
    return true;
  }

  // Public helper for programmatic navigation (plan-filter.js and mexico-plan-filter.js Find My Plan).
  window.csimTagCrossStoreUrl = function (url, linkId) {
    var next = tag(url, linkId);
    try { report(next, linkId); } catch (e) { /* ignore */ }
    return next;
  };

  // Same-store internal link that may carry the landing UTMs before consent.
  // Excludes the other store, external domains, cart, checkout, account, non-http links and
  // same-page #anchors (adding a query would force a reload).
  var SKIP_PATH = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:cart|checkout|checkouts|account)(?:\/|$)/i;
  // Returns the URL with the landing UTMs added, or the original string when the rules do not apply.
  function carryUrl(href) {
    if (!CARRY_UTM_BEFORE_CONSENT || !PAGE_UTM || marketingOk()) return href;
    var u;
    try { u = new URL(href, location.href); } catch (e) { return href; }
    if (u.protocol !== 'https:' && u.protocol !== 'http:') return href;
    if (u.hostname !== location.hostname) return href;         // other store or external domain
    if (SKIP_PATH.test(u.pathname)) return href;               // cart, checkout, account
    if (u.hash && u.pathname === location.pathname && u.search === location.search) return href;
    var p = u.searchParams;
    if (UTM.some(function (k) { return p.has(k); })) return href; // URL already has its own utm_*
    UTM.forEach(function (k) { if (PAGE_UTM[k]) p.set(k, PAGE_UTM[k]); });
    return u.toString();
  }
  function carryInternal(a) {
    var next = carryUrl(a.href);
    if (next !== a.href) a.href = next;
  }
  // Public helper for same-store programmatic navigation (rev 6d). Never throws.
  window.csimCarryUrl = function (url) {
    try {
      if (url && typeof url === 'object' && typeof url.href === 'string') url = url.href;
      return typeof url === 'string' ? carryUrl(url) : url;
    } catch (e) { return url; }
  };

  // After the browser has used the href, drop csim_ho so a second open of the same link gets a new id.
  function dropHandoffId(a) {
    setTimeout(function () {
      try {
        var u = new URL(a.href);
        if (!u.searchParams.has('csim_ho')) return;
        u.searchParams.delete('csim_ho');
        a.href = u.toString();
      } catch (e) { /* ignore */ }
    }, 0);
  }

  // One capture-phase listener. It never calls preventDefault, and errors are swallowed
  // so navigation is never blocked.
  function onPointer(e) {
    try {
      var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
      if (!a) return;
      if (e.type === 'auxclick' && e.button !== 1) return;     // N1a: middle button only
      if (!otherStore(a.href)) { carryInternal(a); return; }  // rev6: same-store carry, nothing else
      var id = a.getAttribute('data-csim-handoff') || a.getAttribute('data-csim-link-id') || '';
      // N1b: pointerdown and contextmenu always mint a fresh csim_ho (with analytics consent);
      // click and auxclick keep it, so pointerdown and click in the same tap match.
      // Keyboard fix: a click with detail 0 (Enter key, assistive tech) has no pointerdown, so it mints one too.
      var fresh = e.type === 'pointerdown' || e.type === 'contextmenu' || (e.type === 'click' && e.detail === 0);
      var next = tag(a.href, id, fresh);
      if (next !== a.href) a.href = next;
      if ((e.type === 'click' || e.type === 'auxclick') && report(next, id)) dropHandoffId(a);
    } catch (err) { /* never block navigation */ }
  }
  ['pointerdown', 'contextmenu', 'click', 'auxclick'].forEach(function (t) {
    document.addEventListener(t, onPointer, true);
  });

  // Landing event (primary count): only once consent state is available.
  var landedDone = false;
  function landed() {
    if (landedDone || !analyticsOk()) return;
    var ho = LANDING.get('csim_ho'), from = LANDING.get('csim_from');
    if (!ho || !from || from === HERE) return;
    landedDone = true;
    try {
      if (sessionStorage.getItem('csim_landed') === ho) return;   // reload guard
      sessionStorage.setItem('csim_landed', ho);
    } catch (e) { /* storage blocked: send anyway */ }
    publish('handoff_landed', {
      handoff_id: ho,
      trigger: LANDING.get('csim_lid') || 'unlabelled',
      csim_from: from
    });
  }

  function onConsentReady() { writeCk(); landed(); }
  document.addEventListener('visitorConsentCollected', function (ev) {
    var d = ev && ev.detail;
    if (d && typeof d.marketingAllowed === 'boolean') mktOverride = d.marketingAllowed;
    onConsentReady();
  });
  var S = window.Shopify;
  if (S && S.customerPrivacy) onConsentReady();
  else if (S && S.loadFeatures) {
    S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) { if (!err) onConsentReady(); });
  }
})();
